import { render, staticRenderFns } from "./ApprovalFilters.vue?vue&type=template&id=f1bf6a5c"
import script from "./ApprovalFilters.vue?vue&type=script&lang=js"
export * from "./ApprovalFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports